const _topBar = document.querySelector('.fancy-header #top-bar');

if (_topBar && !_topBar.classList.contains('bg-gradient')) {
    window.addEventListener('scroll', (event) => {
        if (window.scrollY > 0 && !_topBar.classList.contains('bg-gradient')) {
            _topBar.classList.add('bg-gradient');
        } else if (0 === window.scrollY && _topBar.classList.contains('bg-gradient')) {
            _topBar.classList.remove('bg-gradient');
        }
    });
}

const _navigation = document.getElementById('navigation');

document.addEventListener('click', (event) => {
    if (event.target.classList.contains('js-navigation-toggle-button')) {
        if (_navigation.getAttribute('aria-hidden') === 'true') {
            _navigation.setAttribute('aria-hidden', 'false');
        } else {
            _navigation.setAttribute('aria-hidden', 'true');
        }
    }
});
